export const environment = {
  production: false,
  apiProjectUrl: 'https://a314-projects-dev.oconnell.avwaveinteractive.com/projects',
  apiUrlAdmin: 'https://a314-admin-users-dev.oconnell.avwaveinteractive.com/admin-users',
  apiGoogleStorage: 'https://a314-google-storage-dev.oconnell.avwaveinteractive.com/storage',
  urlStorage: 'https://oconnell-avwave-dev.storage.googleapis.com/',
  testUser: {
    // tslint:disable-line
    token: 'cualquiercosa',
    email: 'user@user.user',
  },
};
